let imageParallaxTrigger = document.querySelectorAll('.co-parallax-image--trigger');
imageParallaxTrigger.forEach(function (imageWrapp) {
  var image = imageWrapp.querySelectorAll('.co-parallax-image img');

  gsap.set(image, { top: "-20%", transition: 0 });
  gsap.to(image, {
    scrollTrigger: {
      trigger: imageParallaxTrigger,
      start: 'top bottom',
      end: "bottom top",
      scrub: 1
    },
    top: "0%"
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const preloader = document.getElementById('preloader');
  preloader.classList.add('loaded');
  //Home accordion
  let carAcc = document.querySelector('.co-home-section-3');
  let coCar1ItemsImages = document.querySelectorAll('.co-home-section-3-images .co-home-section-3-image');

  if (carAcc) {
    var accItems = carAcc.querySelectorAll('.co-home-section-3-item--title');

    // Hide the next sibling element for each item (the content associated with the title)
    accItems.forEach(function (accItem, index) {
      var nextElement = accItem.nextElementSibling;

      if (index === 0 || accItem.parentElement.classList.contains('active')) {
        gsap.to(nextElement, {
          height: 'auto',
          duration: 0.3,
          ease: 'power2.inOut',
        });
        // gsap.to(coCar1ItemsImages[index], {
        //   className: 'z-img-absolute active',
        // });
        coCar1ItemsImages[index].classList.add('active');
      } else {
        gsap.to(nextElement, {
          height: 0,
          duration: 0.3,
          ease: 'power2.inOut',
        });
        // gsap.to(coCar1ItemsImages[index], {
        //   className: 'z-img-absolute',
        // });
        coCar1ItemsImages[index].classList.remove('active');
      }

      // Add a click event listener to each item
      accItem.addEventListener('click', function (e) {
        e.preventDefault();

        // Check if the parent element already has the 'active' class
        if (!this.parentElement.classList.contains('active')) {
          // If not active, hide all other sections
          accItems.forEach(function (otherAccItem, otherIndex) {
            otherAccItem.parentElement.classList.remove('active');
            gsap.to(otherAccItem.nextElementSibling, {
              height: 0,
              duration: 0.3,
              ease: 'power2.inOut',
            });
            // gsap.to(coCar1ItemsImages[otherIndex], {
            //   className: 'z-img-absolute',
            // });
            coCar1ItemsImages[otherIndex].classList.remove('active');
          });

          // Add 'active' class to the clicked item and show its content
          this.parentElement.classList.add('active');

          gsap.to(nextElement, {
            height: 'auto',
            duration: 0.3,
            ease: 'power2.inOut',
          });
          // gsap.to(coCar1ItemsImages[index], {
          //   className: 'z-img-absolute active',
          // });
          coCar1ItemsImages[index].classList.add('active');
        } else {
          this.parentElement.classList.remove('active');
          gsap.to(nextElement, {
              height: 0,
              duration: 0.3,
              ease: 'power2.inOut',
          });
        }
      });
    });

    var firstItem = document.querySelector('.co-home-section-3-item');
    if (firstItem) {
      firstItem.classList.add('active');

      // Show the content of the first item's title
      var firstTitle = firstItem.querySelector('.co-home-section-3-item--title');
      if (firstTitle && firstTitle.nextElementSibling) {
        gsap.to(firstTitle.nextElementSibling, {
          height: 'auto',
          duration: 0.3,
          ease: 'power2.inOut',
        });
      }
    }
  }

  //Compare flips
  // const compareSection = document.querySelector(".co-home-section-5-compare_items");
  // if (compareSection) {
  //   document.querySelectorAll(".co-home-section-5-compare_item").forEach(item => {
  //     item.addEventListener("click", function (e) {
  //       e.preventDefault();
  //       this.classList.toggle("active");
  //     });
  //   });

  //   let flipItem = document.querySelectorAll('.co-home-section-5-compare_item');
  //   gsap.to(flipItem[1], {
  //     scrollTrigger: {
  //       start: 'top center',
  //       end: 'bottom center',
  //       trigger: flipItem[1],
  //       // toggleClass: 'active'
  //       onEnter: (self) => {
  //         flipItem[1].classList.add("active");
  //       }
  //     }
  //   });
  // }


  //Home FAQ accordion
  let faqAcc = document.querySelector('.co-home-section-7');

  if (faqAcc) {
    var faqAccItems = faqAcc.querySelectorAll('.co-home-section-7-tab--link');
    // Hide the next sibling element for each item (the content associated with the title)
    faqAccItems.forEach(function (accItem, index) {
      var nextElement = accItem.nextElementSibling;
      if (index === 0 || accItem.classList.contains('active')) {
        accItem.classList.add('active');
        nextElement.classList.add('active');

        gsap.to(nextElement, {
          height: 'auto',
          opacity: 1,
          duration: 0.3,
          ease: 'power2.inOut',
        });
      } else {
        nextElement.classList.remove('active');

        if (window.matchMedia("(max-width: 749px)").matches) {
          gsap.to(nextElement, {
            height: 0,
            // opacity: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        } else {
          gsap.to(nextElement, {
            // height: 0,
            opacity: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        }
      }

      // Add a click event listener to each item
      accItem.addEventListener('click', function (e) {
        e.preventDefault();
        // Check if the parent element already has the 'active' class
        if (!this.classList.contains('active')) {
          // If not active, hide all other sections
          faqAccItems.forEach(function (otherAccItem, otherIndex) {
            otherAccItem.classList.remove('active');
            otherAccItem.nextElementSibling.classList.remove('active');

            if (window.matchMedia("(max-width: 749px)").matches) {
              gsap.to(otherAccItem.nextElementSibling, {
                height: 0,
                // opacity: 0,
                duration: 0.3,
                ease: 'power2.inOut',
              });
            } else {
              gsap.to(otherAccItem.nextElementSibling, {
                // height: 0,
                opacity: 0,
                duration: 0.3,
                ease: 'power2.inOut',
              });
            }
          });
          // Add 'active' class to the clicked item and show its content
          this.classList.add('active');
          nextElement.classList.add('active');
          gsap.to(nextElement, {
            opacity: 1,
            height: 'auto',
            duration: 0.3,
            ease: 'power2.inOut',
          });
        }
        // If already active, don't hide the content
      });

    });
  }


  //FAQ Page 



  //FAQ Page group accordion
  let groupAccWrapp = document.querySelectorAll('.co-faq-section-2');
  groupAccWrapp.forEach(function (groupAcc) {
    if (groupAcc) {
      var groupAccItems = groupAcc.querySelectorAll('.co-faq-section-2-group-item--title');
      // Hide the next sibling element for each item (the content associated with the title)
      groupAccItems.forEach(function (groupItem, index) {
        var nextElement = groupItem.nextElementSibling;
        if (index === 0 || groupItem.classList.contains('active')) {
          groupItem.classList.add('active');
          nextElement.classList.add('active');

          gsap.to(nextElement, {
            height: 'auto',
            duration: 0.3,
            ease: 'power2.inOut',
          });
        } else {
          nextElement.classList.remove('active');
          gsap.to(nextElement, {
            height: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        }

        // Add a click event listener to each item
        groupItem.addEventListener('click', function (e) {
          e.preventDefault();
          // Check if the parent element already has the 'active' class
          if (!this.classList.contains('active')) {
            // If not active, hide all other sections
            groupAccItems.forEach(function (otherAccItem, otherIndex) {
              // otherAccItem.classList.remove('active');
              // otherAccItem.nextElementSibling.classList.remove('active');

              // gsap.to(otherAccItem.nextElementSibling, {
              //   height: 0,
              //   duration: 0.3,
              //   ease: 'power2.inOut',
              // });
            });
            // Add 'active' class to the clicked item and show its content
            this.classList.add('active');
            nextElement.classList.add('active');
            gsap.to(nextElement, {
              height: 'auto',
              duration: 0.3,
              ease: 'power2.inOut',
            });

            // groupItem.scrollIntoView({block: "start", behavior: "smooth"});
            // console.log(groupItem);
            // const itemYPos = this.getBoundingClientRect().top;
            // window.scrollTo({top: itemYPos, behavior: 'smooth'});
          } else {
            this.classList.remove('active');
            nextElement.classList.remove('active');
            gsap.to(nextElement, {
              height: 0,
              duration: 0.3,
              ease: 'power2.inOut',
            });
          }
          // If already active, don't hide the content
        });

      });
    }
  });

  if (!document.documentElement.classList.contains('shopify-design-mode')) {
    imageFade('.coImageFade');
    textFade('.coTextFade');
    simpleFade('.coItemFade');

    if (window.matchMedia("(min-width: 750px)").matches) {

      // let preFoot = document.querySelectorAll(".shopify-section:last-child");

      const preFootEls = document.querySelectorAll('main .shopify-section');
      const preFoot = preFootEls[preFootEls.length - 1] || null;

      // ScrollTrigger.create({
      //   trigger: preFoot,
      //   pin: true,
      //   pinSpacing: false,
      //   start: "bottom bottom",
      //   markers: false,
      //   // invalidateOnRefresh: true,
      // });

      window.addEventListener("resize", function () {
        // ScrollTrigger.refresh();
      });
    }

    function initializeWalkingAnimation() {
      const element = '.co-home-section-4-animation';
      const walkD = document.querySelectorAll('.co-home-section-4-frame')[0].getBoundingClientRect().width;
      const manW = document.querySelectorAll('.co-home-section-4-animation')[0].getBoundingClientRect().width;
      const walkPath = walkD - manW;
      const coLeftLeg = document.getElementById('leg-left');
      const coRightLeg = document.getElementById('leg-right');

      let walkMultip = 0.7;
      if (window.matchMedia("(min-width: 750px)").matches) {
        walkMultip = 0.5;
      }

      const timelineW = gsap.timeline({
        scrollTrigger: {
          trigger: '.co-home-section-4',
          scrub: 0.1,
          start: "-550 top",
          end: "bottom center",
          ease: "power2.out",
          onUpdate: (self) => {
            document.querySelectorAll('.co-home-section-4-animation')[0].classList.add('animated');
            self.direction === -1 ? coMotionPathFlipLeft() : coMotionPathFlipRight();
          },
          onScrubComplete: (self) => {
            document.querySelectorAll('.co-home-section-4-animation')[0].classList.remove('animated');
          }
        }
      });
      timelineW.to(element, {
        duration: 4,
        x: walkPath * walkMultip
      });

      let repeatWalkAnim = 1;
      if (window.matchMedia("(min-width: 750px)").matches) {
        repeatWalkAnim = 2;
      }
      gsap.set(coLeftLeg, { attr: { style: "transform: translate(0%, 0%) rotate(-1deg);" } });
      const timelineLL = gsap.timeline({
        scrollTrigger: {
          trigger: '.co-home-section-4',
          scrub: true,
          start: "-550 top",
          end: "bottom center",
          ease: "power2.out",
        },
        repeat: repeatWalkAnim,
      });

      timelineLL
        .to(coLeftLeg, { attr: { style: "transform: translate(4.5%, 1%) rotate(48deg);" } })
        .to(coLeftLeg, { attr: { style: "transform: translate(0%, 0%) rotate(-1deg);" } })


      gsap.set(coRightLeg, { attr: { style: "transform: translate(0%, 0%) rotate(2deg);" } });
      const timelineRL = gsap.timeline({
        scrollTrigger: {
          trigger: '.co-home-section-4',
          scrub: true,
          start: "-550 top",
          end: "bottom center",
          ease: "power2.out",
        },
        repeat: repeatWalkAnim,
      });

      timelineRL
        .to(coRightLeg, { attr: { style: "transform: translate(-7%, -3%) rotate(-42deg);" } })
        .to(coRightLeg, { attr: { style: "transform: translate(0%, 0%) rotate(2deg);" } })

    }
    function coMotionPathFlipLeft() {
      gsap.to(".co-home-section-4-animation", { rotateY: 180, duration: 0.1 });
    }
    function coMotionPathFlipRight() {
      gsap.to(".co-home-section-4-animation", { rotateY: 0, duration: 0.1 });
    }

    const walkingSection = document.querySelector(".co-home-section-4");
    if (walkingSection) {
      initializeWalkingAnimation();
    }
  }



  //Simple Accordion
  var coAccItems = document.querySelectorAll('.co-accordion--title');
  // Hide the next sibling element for each item (the content associated with the title)
  coAccItems.forEach(function (groupItem, index) {
    var nextElement = groupItem.nextElementSibling;
    if (index === 0 || groupItem.classList.contains('active')) {
      groupItem.classList.add('active');
      nextElement.classList.add('active');

      gsap.to(nextElement, {
        height: 'auto',
        duration: 0.3,
        ease: 'power2.inOut',
      });
    } else {
      nextElement.classList.remove('active');
      gsap.to(nextElement, {
        height: 0,
        duration: 0.3,
        ease: 'power2.inOut',
      });
    }

    // Add a click event listener to each item
    groupItem.addEventListener('click', function (e) {
      e.preventDefault();
      
      // Check if the parent element already has the 'active' class
      if (!this.classList.contains('active')) {
        // If not active, hide all other sections
        coAccItems.forEach(function (otherAccItem, otherIndex) {
          otherAccItem.classList.remove('active');
          otherAccItem.nextElementSibling.classList.remove('active');

          gsap.to(otherAccItem.nextElementSibling, {
            height: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        });
        // Add 'active' class to the clicked item and show its content
        this.classList.add('active');
        nextElement.classList.add('active');
        gsap.to(nextElement, {
          height: 'auto',
          duration: 0.3,
          ease: 'power2.inOut',
        });
      }
      // If already active, don't hide the content
    });

  });

});

window.addEventListener('resize', function (event) {
  // ScrollTrigger.refresh();
}, true);

function imageFade(imageQ) {
  let image = document.querySelectorAll(imageQ);
  image.forEach(function (imageItem, index) {
    let timelineI = gsap.timeline();
    gsap.set(imageItem, { opacity: 0, yPercent: 10 });
    timelineI.to(imageItem, {
      duration: 1,
      opacity: 1,
      yPercent: 0,
      ease: "power2.out",
      delay: (index / 100)
    });
    ScrollTrigger.create({
      trigger: imageItem,
      // start: "top 110%",
      end: "bottom bottom",
      toggleActions: "play none none none",
      // toggleActions: "restart none none reverse",
      animation: timelineI
    });
  });
}

function textFade(textQ) {
  let text = document.querySelectorAll(textQ);
  text.forEach(function (textItem, index) {
    let timelineT = gsap.timeline();
    gsap.set(textItem, { opacity: 0, yPercent: 20 });
    timelineT.to(textItem, {
      duration: 1,
      opacity: 1,
      yPercent: 0,
      ease: "power2.out",
      delay: (index / 100)
    });
    ScrollTrigger.create({
      trigger: textItem,
      // start: "top 110%",
      end: "bottom bottom",
      toggleActions: "play none none none",
      // toggleActions: "restart none none reverse",
      animation: timelineT
    });
  });
}

function simpleFade(itemQ) {
  let item = document.querySelectorAll(itemQ);
  item.forEach(function (Item, index) {
    let timelineS = gsap.timeline();
    gsap.set(Item, { opacity: 0, yPercent: 2 });
    timelineS.to(Item, {
      duration: 1,
      opacity: 1,
      yPercent: 0,
      ease: "power2.out",
      delay: (index / 100)
    });
    ScrollTrigger.create({
      trigger: Item,
      // start: "top 110%",
      end: "bottom bottom",
      toggleActions: "play none none none",
      // toggleActions: "restart none none reverse",
      animation: timelineS
    });
  });
}
